import React, {useState} from 'react';
import './SignUpText.css';
import NormalBtn from './NormalBtn';

export default function App(props) {

  var infoPieces = props.origInfo;
  var submitUserInfo = props.submitUserInfo;
  var width = props.width;
  var adminAction = props.adminAction;

  const [userName, setUserName] = useState(infoPieces[0].v);
  const [postalCode, setPostalCode] = useState(infoPieces[1].v);
  const [unitNos, setUnitNos] = useState(infoPieces[2].v);
  const [addressLine, setAddressLine] = useState(infoPieces[3].v);
  const [phoneNumber, setPhoneNumber] = useState(infoPieces[4].v);
 
  var pieces = [{t:"Name", v:userName, f:setUserName, editable:true}, {t:"Postal Code", v:postalCode, f:setPostalCode, editable:true}, {t:"Unit Number", v:unitNos, f:setUnitNos, editable:true}, {t:"Address", v:addressLine, f:setAddressLine, editable:false}, {t:"Phone Number", v:phoneNumber, f:setPhoneNumber, editable:true}];

  function changeValue(aPiece){
    return function(e){
      aPiece.f(e.target.value);
    }
  }

  function updateAddress(response){
    if (response.t === "binary"){
      setAddressLine(response.v);
    }else{
      setAddressLine("Unknown postal code");
    } 
  }

  function onBlur(aPiece){
    return function(e){
      if (aPiece.t === "Postal Code"){
        var trimPostal = postalCode.trim();
        adminAction("getAddressFromPostal", {postalCode:trimPostal}, updateAddress);
      }    
    }    
  }

  var rows = pieces.map((aPiece, index)=>{
    var concreteText = <input key="constructorTerm" autoComplete="none" type="text" className="textFieldPieceNoColor" style={{width:"80%"}} placeholder="" value={aPiece.v} onChange={changeValue(aPiece)} onBlur={onBlur(aPiece)} />
    if (!aPiece.editable){
      if (aPiece.v){
        concreteText = <div>{aPiece.v}</div>
      }else{
        concreteText = <div>Fill in postal code to generate address</div>
      }
//
    }
    return <tr key={index}><td>{aPiece.t}</td>
            <td>{concreteText}</td>
          </tr>
  })
//
  function submitPiece(){
    for (var i = 0; i < pieces.length; i++){
      var aPiece = pieces[i];
      if (aPiece.v.trim() === ""){
        window.alert(aPiece.t + " cannot be blank");
        return;
      }
    }

    if (addressLine === "Unknown postal code"){
      window.alert("Sorry, we do not recognize this postal code");
      return;
    }

    var p = window.confirm("Do you agree for us or other organisations to contact or visit you to share updates, new benefits and announcements from the Government, make appointments with you or facilitate the provision of services or assistance to you or your family?");
    if (p){
      submitUserInfo(userName, postalCode, addressLine, unitNos, phoneNumber);
    }

  }

  var buttonRow = [];
  buttonRow.push(<NormalBtn onClick={submitPiece} title="Submit" />)
  var style = {};
  if (width){
    style.width = width * 0.8;
  }
    return (<div style={style}>
              <table width="100%">
                <tbody>
                  {rows}
                </tbody>
              </table>
              {buttonRow}
            </div>
    );
  
}

